import * as React from "react";
import { forwardRef } from "react";
const SvgFunnel = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M6.2 12.91A.3.3 0 0 1 6 13h-.91a.3.3 0 0 1-.3-.3V7.04a.3.3 0 0 0-.07-.19L.07 1.2A.3.3 0 0 1 0 .99V.3C0 .13.13 0 .3 0h12.4c.17 0 .3.13.3.3V1a.3.3 0 0 1-.06.18L8.5 6.85a.3.3 0 0 0-.06.18v3.47a.3.3 0 0 1-.09.21l-2.14 2.2Zm-.5-.87a.03.03 0 0 0 .05.02l1.7-1.73a.3.3 0 0 0 .08-.21V6.7a.3.3 0 0 1 .06-.19l4-5.1a.3.3 0 0 0-.25-.49H1.7a.3.3 0 0 0-.24.5L5.63 6.5a.3.3 0 0 1 .07.2v5.33Z" }));
const ForwardRef = forwardRef(SvgFunnel);
export default ForwardRef;
